// extracted by mini-css-extract-plugin
export default {"wrapper":"uA-z","button":"vA-z","alternate":"wA-z","disabled":"xA-z","paymentWarning":"yA-z","fadeIn":"zA-z"};